import type { CSSProperties } from 'react';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

/**
 * App-root toast mount, backed by sonner. Mount once near the app root (done in both apps'
 * App.tsx). Trigger toasts via the `useToast` hook, not this component directly.
 *
 * Design tokens are stored as full OKLCH color values (see packages/shared/src/styles/tokens.css),
 * so these CSS vars are consumed directly — no hsl()/color-function wrapper needed.
 */
function Toaster(props: ToasterProps) {
  return (
    <Sonner
      className="toaster group"
      position="bottom-right"
      toastOptions={{ classNames: { actionButton: 'bg-primary! text-primary-foreground!' } }}
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
          '--border-radius': 'var(--radius)',
        } as CSSProperties
      }
      {...props}
    />
  );
}

export { Toaster };
